<template>
    
<div id="wrap">


    <transition name="slide-up">
<div v-if="enabled" id="container">

<div id="content">
     <h2>How to Play</h2>

     <p>
        Welcome to Higher or Lower for Spotify Artists.
    </p>


        <h1 style="font-size:2em; margin:0em; text-align:center;">👩🏼👳🏾‍♂️👧🏿🧑🏻👨🏽‍🦰</h1>

      <p>
        Your goal is to guess the artist with more Spotify followers
    </p>


<div id="images" >
     <img src="../assets/status/ok.svg" alt="what">
     <img src="../assets/status/cancel.svg" alt="what">
</div>
    <p>If your guess is correct, you will move onto the next round. Make consecutive correct guesses to increase your score!</p>


        <h1 style="font-size:3em; margin:0; ">
            📈
        </h1>
      <p style="margin-bottom:2em; ">
        Artists are selected from Spotify's list of the Top 200 Artists in Canada
    </p>

</div>
   
</div>
    </transition>

</div>
</template>


<script>
export default {
    
    props:{
        enabled:Boolean
    }
}
</script>

<style scoped>

#wrap{
     filter: drop-shadow(-5px 5px 10px rgba(0, 0, 0, 0.558));
      z-index: 2000;
        position: absolute;
        
    /* height:70vh;  */
    width:40vw; 
    left:calc(80px - 40vw); 
    top:35%;
}
#container{
    border-radius:1.5em;
    
    background-color: white;
  
   /* height:70vh;  */
    /* width:40vw; 
    left: calc(80px - 40vw); 
    top:35%; */

}

@media (max-aspect-ratio: 5/6) {
   
   #wrap{
    width:80vw; 
     left: calc(80px - 80vw); 
   }
}

#content{
display: flex;
flex-direction: column;
align-items: center;
color:#2b3d4f;
width:100%; 
height: 100%;
}
h2{
    font-weight: 800;
}

#content p{
    width:50%; 
    font-weight: 600;
    font-size: 1em;
    padding: 1em;
    text-align: center;
}

#images img{
    margin:1em; 
    margin-inline: 1.4em;
transform: scale(170%);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.5s linear;
   clip-path: circle(200% at 95% 30px );
   

}

.slide-up-enter-from {
 
 clip-path: circle(0% at 95% 30px);
 
}

.slide-up-leave-to {
 
   clip-path: circle(0% at 95% 30px );
   
}



</style>